import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import css from './index.scss';
import inputStyle from './text-input.scss';
import TextInput from '../text-input/index';
import DropDownList from '../dropdown-list/index';
import listStyle from './dropdown-list.scss';
import Button from '../button/index';
import { Download } from '../../helpers/icon-dictionary';
import messages from './messages';

class TeacherDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showResetPasswordSection: false,
            email: props.teacher.emailAddress
        };
    }

    handleOnPrintSignInCard = () => {
        this.props.handleOnPrintSignInCard();
    }
    renderPasswordSection = showVerifyEmailLink => (<div className={this.props.css.passwordButtonSection}>
        <div>
            {
                this.state.showResetPasswordSection ? (<div>
                    <div className={this.props.css.passwordSection}>
                        <div
                            className={this.props.css.passwordLabel}>{this.props.intl.formatMessage(messages.newTeacherPassword)}</div>
                        <div className={this.props.css.password}><TextInput
                            css={inputStyle}
                            handleOnChange={this.props.handleOnPasswordInputChange}
                            maxLength={25}
                            name="newPassword"
                            type="password"
                        /></div>
                    </div>
                    <div className={this.props.css.passwordSection}>
                        <div
                            className={this.props.css.passwordLabel}>{this.props.intl.formatMessage(messages.repeatTeacherPassword)}</div>
                        <div className={this.props.css.password}><TextInput
                            css={inputStyle}
                            handleOnChange={this.props.handleOnPasswordInputChange}
                            maxLength={25}
                            name="confirmationPassword"
                            type="password"
                        /></div>
                    </div>
                    <div className={this.props.css.passwordSection}>
                        <div className={this.props.css.passwordLabel} />
                        <div className={this.props.css.informationMessage}>
                            <div
                                className={this.props.css.warning}> {this.props.intl.formatMessage(messages.warning)} </div>
                            <div
                                className={this.props.css.warning}> {this.props.intl.formatMessage(messages.passwordWarning)} </div>
                        </div>
                    </div>
                </div>) : (<div />)
            }
        </div>
        <div className={this.props.css.linkButtonPanel}>
            <div className={this.props.css.linkButtons}>
                <Button
                    containerClassName={this.props.css.downloadSignInCards}
                    disabled={!this.props.isSignInCardDownloaded}
                    handleOnClick={this.handleOnPrintSignInCard}
                    icon={Download}
                    iconClassName={this.props.css.iconClassName}
                    label={this.props.intl.formatMessage(messages.downloadSignInCard)}
                    loading={!this.props.isSignInCardDownloaded}
                    loadingLabel={this.props.intl.formatMessage(messages.downloading)} />
            </div>
            <div className={this.props.css.linkButtons}>
                <Button
                    containerClassName={this.props.css.downloadSignInCards}
                    disabled={!this.state.email}
                    handleOnClick={() => this.props.handleOnSendTeacherPassword('passwordReset')}
                    label={this.props.intl.formatMessage(messages.teacherPasswordLink)}
                />
            </div>
            { showVerifyEmailLink && <div className={this.props.css.linkButtons}>
                <Button
                    containerClassName={this.props.css.downloadSignInCards}
                    disabled={!this.state.email || this.props.teacher.isEmailVerified}
                    handleOnClick={() => this.props.handleOnSendTeacherPassword('verifyEmail')}
                    label={this.props.intl.formatMessage(messages.teacherVerifyEmailLink)}
                />
            </div>}
        </div>
    </div>);

    onSelection = (element) => {
        this.setState({ showResetPasswordSection: element.target.checked });
        this.props.resetPassword(element.target.checked);
    }

    render() {
        //  window.pppAppConfig returns string values from configuration
        const showVerifyEmailLink = window.pppAppConfig ? window.pppAppConfig.showVerifyEmailLink === 'true' : false;

        const title = this.props.teacher.title.toString() === '' ? 'None' : this.props.teacher.title.toString();

        return (
            <div className={this.props.css.teacherDetailContainer}>
                <div
                    className={this.props.css.teacherDetailHeader}>{this.props.intl.formatMessage(messages.teacherDetails)}</div>
                <div className={this.props.css.panel}>
                    <div className={this.props.css.leftPanel}>
                        <div className={this.props.css.dataItem}>
                            <div className={this.props.css.label}>{this.props.intl.formatMessage(messages.title)}</div>
                            <div className={this.props.css.list}>
                                <DropDownList
                                    css={listStyle}
                                    name="title"
                                    onChange={this.props.handleOnListChange}
                                    options={this.props.teacherTitles}
                                    value={title} /></div>
                        </div>
                        <div className={this.props.css.dataItem}>
                            <div
                                className={this.props.css.label}>{this.props.intl.formatMessage(messages.firstname)}</div>
                            <TextInput
                                css={inputStyle}
                                handleOnChange={this.props.handleOnTextInputChange}
                                maxLength={50}
                                name="firstName"
                                value={this.props.teacher.firstName}
                            />
                        </div>
                        <div className={this.props.css.dataItem}>
                            <div
                                className={this.props.css.label}>{this.props.intl.formatMessage(messages.lastname)}</div>
                            <TextInput
                                css={inputStyle}
                                handleOnChange={this.props.handleOnTextInputChange}
                                maxLength={50}
                                name="lastName"
                                value={this.props.teacher.lastName}
                            />
                        </div>
                        <div className={this.props.css.dataItem}>
                            <div
                                className={this.props.css.label}>{this.props.intl.formatMessage(messages.emailaddress)}
                            </div>
                            {
                                showVerifyEmailLink && this.state.email && !this.props.teacher.isEmailVerified ?
                                    (<div className={this.props.css.dataItem}>
                                        <div
                                            className={this.props.css.label}>&nbsp;</div>
                                        <div className={this.props.css.emailUnverified}>
                                            {this.props.intl.formatMessage(messages.emailUnverified)}</div>
                                    </div>) : ''
                            }
                            <TextInput
                                css={inputStyle}
                                handleOnChange={this.props.handleEmailInputOnChange}
                                maxLength={70}
                                name="emailAddress"
                                value={this.props.teacher.emailAddress}
                            />
                        </div>
                    </div>
                    <div className={this.props.css.rightPanel}>
                        <div className={this.props.css.dataItem}>
                            <div
                                className={this.props.css.label}>{this.props.intl.formatMessage(messages.username)}</div>
                            <TextInput
                                css={inputStyle}
                                disabled
                                maxLength={50}
                                name="userName"
                                value={this.props.teacher.userName}
                            />
                        </div>
                        <div className={this.props.css.buttonPanel}>
                            <div className={this.props.css.reset}>
                                <div className={this.props.css.checkbox}>
                                    <input
                                        className={this.props.css.name}
                                        id="chkResetPassword"
                                        onChange={this.onSelection}
                                        type="checkbox"
                                    />
                                    <label className={this.props.css.chklabel} htmlFor="chkResetPassword" />
                                    <span
                                        className={this.props.css.className}>{this.props.intl.formatMessage(messages.resetTeacherPassword)}</span>
                                </div>
                            </div>
                        </div>
                        <div>
                            {this.renderPasswordSection(showVerifyEmailLink)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

TeacherDetails.propTypes = {
    css: PropTypes.object,
    teacher: PropTypes.object,
    teacherTitles: PropTypes.arrayOf(PropTypes.object),
    handleOnTextInputChange: PropTypes.func,
    handleEmailInputOnChange: PropTypes.func,
    handleOnListChange: PropTypes.func,
    handleOnPrintSignInCard: PropTypes.func,
    isSignInCardDownloaded: PropTypes.bool,
    intl: intlShape.isRequired,
    handleOnPasswordInputChange: PropTypes.func,
    handleOnSendTeacherPassword: PropTypes.func,
    resetPassword: PropTypes.func
};

export default injectIntl(styleable(css)(TeacherDetails));



// WEBPACK FOOTER //
// ./app/components/teacher-details/index.js